import React, { useEffect, useContext, useState, useRef } from "react";
import { useHistory } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  formatPrice,
  getSystemSettings,
  customStyle,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import moment from "moment";
import Select from "react-select";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useReactToPrint } from "react-to-print";

//pages & includes
import ReportSidebar from "./ReportSidebar";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { UserContext } from "../../../../contexts/User";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import CustomSpinLoader from "../../../components/CustomSpinLoader";
import ReportTypeOptions from "../../../components/Reports/ReportTypeOptions";
import ReportExcelPrintGap from "../../../components/Reports/ReportExcelPrintGap";

let groupArr = [
  { id: 1, name: "Document No" },
  { id: 2, name: "Document Date" },
  { id: 3, name: "Customer" },
  { id: 4, name: "Branch" },
];

const postOptions = [
  {
    id: "",
    name: "All"
  },
  {
    id: 0,
    name: "Un Post"
  },
  {
    id: 1,
    name: "Post"
  }
]

const SaleInvoiceReport = () => {
  const { t } = useTranslation();
  // const history = useHistory();
  //getting context values here
  let {
    loading,
    setLoading,
    dataPaginating,
    setDataPaginating,
    generalSettings,
  } = useContext(SettingsContext);
  const { customerForSearch, getCustomer } = useContext(UserContext);
  let {
    branchForSearch,
  } = useContext(RestaurantContext);

  //all data
  const [reportData, setReportData] = useState(null);
  const componentRef = useRef();
  const componentRefThermal = useRef();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [branch, setBranch] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [group, setGroup] = useState(groupArr[3]);
  const [isPost, setIsPost] = useState(postOptions[0]);
  const [generatedReport, setGeneratedReport] = useState(false);
  const [option, setOption] = useState("excel");
  const [reportOption,setReportOption] = useState("detail")

  useEffect(() => {
    if (!customerForSearch) {
      getCustomer();
    }

    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [generalSettings]);

  let common_toast = {
    position: "bottom-center",
    closeButton: false,
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  };

  const handleSetType = (e)=>{
    setReportOption(e.target.value)
  }

  const handleBranch = (branch) => {
    setBranch(branch);
  };

  const handleSetOption = (value)=>{
    setIsPost(value)
  }

  const handleOption = (e) => {
    setOption(e.target.value);
  };

  const handleCustomer = (cust) => {
    setCustomer(cust);
  };

  const thermalPrint = useReactToPrint({
    content: () => componentRefThermal.current,
    pageStyle: `
        @page {
          margin: 15px 7px;
        }
      `,
  });

  //get excel reports filter
  const getExcelReport = () => {
    setReportData(null);
    setGeneratedReport(false);
    if (startDate !== null && endDate !== null && group !== null) {
      getReport();
    } else {
      toast.error(
        `${_t(t("Please select from date, to date and group"))}`,
        common_toast
      );
    }
  };

  //get sale inv report
  const getReport = async () => {
    setDataPaginating(true);
    let fromDate = moment(startDate).format("YYYY-MM-DD");
    let toDate = moment(endDate).format("YYYY-MM-DD");
    const url = BASE_URL + "/settings/get-sale-invoice-report";
    let formData = new FormData();
    formData.append("fromDate", fromDate);
    formData.append("toDate", toDate);
    formData.append("branch_id", branch?.id ?? "");
    formData.append("type", reportOption)
    formData.append("customer_id", customer?.id ?? "");
    formData.append("is_post", isPost?.id ?? "");
    formData.append("group_by", group.name);

    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setGeneratedReport(true);
        setReportData(res.data);
        setDataPaginating(false);
        if (option === "excel") {
          componentRef.current.handleDownload();
        } else {
          thermalPrint();
        }
      })
      .catch((error) => {
        setDataPaginating(false);
        toast.error(`${_t(t("Please try again"))}`, common_toast);
      });
  };

  const header = [
    { name: "Group Name", key: "group_name" },
    { name: "Document Id", key: "document_identity", gap:1 },
    { name: "Date", render:(item)=> <Moment format="LL">{item.document_date}</Moment>},
    { name: "Branch", key: "branch_name" },
    { name: "Customer", key: "customer_name" },
    { name: "Ingredient Name", key: "ingredient_name" },
    { name: "Unit", key: "unit" },
    { name: "Payment Type", key: "payment_type" },
    { name: "Qty", key: "qty" },
    { name: "Rate", key:"rate", total: 1},
    { name: "Amount", key:"amount" ,total: 1},
    { name: "Discount", key:"discount" ,total: 1},
    { name: "Tax Amount", key:"tax" ,total: 1},
    { name: "Total Amount", key:"total" ,total: 1},
  ];

  const headerSummary = [
    { name: "Group Name", key: "group_name" },
    { name: "Document Id", key: "document_identity", gap:1 },
    { name: "Date", render:(item)=> <Moment format="LL">{item.document_date}</Moment>},
    { name: "Branch", key: "branch_name" },
    { name: "Customer", key: "customer_name" },
    { name: "Payment Type", key: "payment_type" },
    { name: "Amount", key:"total_amount" ,total: 1},
    { name: "Discount", key:"total_discount" ,total: 1},
    { name: "Tax Amount", key:"total_tax" ,total: 1},
    { name: "Total Amount", key:"total_bill" ,total: 1},
  ];

  return (
    <>
      <Helmet>
        <title>{_t(t("Sale Invoice Report"))}</title>
      </Helmet>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename={reportOption === "summary" ? "Sale Invoice Summary Report" : "Sale Invoice Detail Report"}
        sheet="sheet 1"
        buttonText="Sale Invoice Detail"
        ref={componentRef}
      />

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading || dataPaginating} />

                    {/* spin loading ends */}

                    <div key="smtp-form">
                      <div className="gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="row t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb col-6">
                            <li className="fk-breadcrumb__list">
                              <span className="pl-3 t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Sale Invoice Report"))}
                              </span>
                            </li>
                          </ul>
                          <div className="col-6 d-flex justify-content-end">
                            <ReportTypeOptions
                              selectedOption={option}
                              onChange={handleOption}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-2 d-md-block">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>

                        <div className="col-2 d-md-block">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText={_t(t("To date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>

                        <div className="col-3">
                          <Select
                            options={branchForSearch ? branchForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={branch}
                            classNamePrefix="select"
                            isClearable
                            className="table-text"
                            onChange={handleBranch}
                            styles={customStyle}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a branch")) + ".."}
                          />
                        </div>

                        <div className="col-2 mt-0">
                          <div className="mt-0 lg-text">
                            <input
                              type="radio"
                              className="form-check-input pointer-cursor"
                              id="detail"
                              name="detail"
                              value="detail"
                              onChange={(e) => handleSetType(e)}
                              checked={reportOption === "detail"}
                            />
                            <label
                              className="form-radio-label pointer-cursor ml-2"
                              htmlFor="detail"
                            >
                              {_t(t("Detail"))}
                            </label>
                          </div>
                          <div className="mt-1 lg-text">
                            <input
                              type="radio"
                              className="form-check-input pointer-cursor"
                              id="summary"
                              name="summary"
                              value="summary"
                              onChange={(e) => handleSetType(e)}
                              checked={reportOption === "summary"}
                            />
                            <label
                              className="form-radio-label pointer-cursor ml-2"
                              htmlFor="summary"
                            >
                              {_t(t("Summary"))}
                            </label>
                          </div>

                        </div>
                        <div className="col-2">
                          <Select
                            options={
                              postOptions
                                ? postOptions
                                : []
                            }
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={isPost}
                            styles={customStyle}
                            isClearable
                            classNamePrefix="select"
                            className="table-text"
                            onChange={handleSetOption}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select option")) + ".."}
                          />
                        </div>
                      </div>
                      <div className="row mt-3">

                        <div className="col-3">
                          <Select
                            options={customerForSearch ? customerForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={customer}
                            styles={customStyle}
                            isClearable
                            classNamePrefix="select"
                            className="table-text"
                            onChange={handleCustomer}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a customer")) + ".."}
                          />
                        </div>
                        <div className="col-2">
                          <Select
                            options={groupArr && groupArr}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={group}
                            styles={customStyle}
                            isClearable
                            classNamePrefix="select"
                            className="table-text"
                            onChange={(group) => setGroup(group)}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select group")) + ".."}
                          />
                        </div>

                        <div className="col-5"></div>

                        <div className="col-2 t-mb-15 mb-md-0 text-right">
                          <button
                            className="ml-1 btn btn-block btn-primary sm-text py-2 rounded"
                            onClick={(e) => getExcelReport()}
                          >
                            GENERATE REPORT
                          </button>
                        </div>
                      </div>
                      <ReportExcelPrintGap
                        header={reportOption === "summary" ? headerSummary : header}
                        generatedReport = {generatedReport}
                        heading={reportOption === "summary" ? "Sale Invoice Summary Report" : "Sale Invoice Detail Report"}
                        reportData={reportData}
                        startDate={startDate}
                        endDate={endDate}
                        componentRef={componentRef}
                        printRef={componentRefThermal}
                        branch={{
                          name: branch?.length ? branch.map((branh,i)=> branh.name + (i < branch?.length -1) ? ", " : "" ) : "All Branch",
                          show: true,
                        }}
                        type = {option}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
    </>
  );
};

export default SaleInvoiceReport;
